export default function removeTrailingLetters(string) {
  return string ? string.replace(/ (\w{1})\s/gi, ' $1&nbsp;') : '';
}
